// Webpack entry point
import "./scss/styles.scss";
import "./js/scripts";
